import React, { useState, useEffect, useCallback, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { format, addDays, isValid, parse } from 'date-fns';
import IconButton from '@mui/material/IconButton';

import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import Rating from '@mui/material/Rating';

import Menu from "@mui/material/Menu";

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';


import api from '../../../../../../services/api';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';



import ButtonGroup from '@material-ui/core/ButtonGroup';



import { styled } from '@material-ui/styles';





const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};

export default function AtualizarProcedimentoExecucao({
    instalacaoSelecionada,
    idEntradaEstoque,
    procedimentoExecucao,
    ordemServico,
}) {


    const [botaoClicado, setBotaoClicado] = useState(false);
    const [tabela, setTabela] = useState([]);



    const salvar = () => {
        // Verifica se o botão já foi clicado
        if (!botaoClicado) {
            // Executa a lógica do clique aqui
            console.log('Botão clicado!');

            // Atualiza o estado para indicar que o botão foi clicado
            setBotaoClicado(true);
            funcaoSalvar();
        }
    };

    const idProcedimentoExecucao = procedimentoExecucao?.id_procedimento_execucao;
    const idOrdemServico = ordemServico?.id_ordem_servico;


    const [itemOrdemCompra, setItemOrdemCompra] = useState(null);

    const [unidadeBase, setUnidadebase] = useState(null);


    const [armazenamentoSelecionado, setArmazenamentoSelecionado] = useState(null);
    const [armazenamentos, setArmazenamentos] = useState([]);

    const [dataInicial, setDataInicial] = useState(format(new Date(), 'dd/MM/yyyy'));
    const [horaInicial, setHoraInicial] = useState("08:00");
    const [dataFinal, setDataFinal] = useState(format(addDays(new Date(), 7), 'dd/MM/yyyy'));
    const [horaFinal, setHoraFinal] = useState("12:00");

    const history = useHistory();

    const [observacoes, setObservacoes] = useState('');
    const [resultado, setResultado] = useState(1);
    const [quantidadesAceitos, setQuantidadesAceitos] = useState("");
    const [quantidadesAveriguados, setQuantidadesAveriguados] = useState("");
    const [quantidadesRecebidos, setQuantidadesRecebidos] = useState("");


    async function funcaoSalvar() {


        try {

            console.log("cadastrar chamado");

            const formData = new FormData();

            // Adicionar os dados do procedimento
            formData.append('id_procedimento_execucao', procedimentoExecucao.id_procedimento_execucao);
            formData.append('usuario_executor.id_usuario', Cookies.get('id_usuario'));
            formData.append('observacoes', observacoes);
            formData.append('resultado', 1);
             formData.append('id_usuario', Cookies.get('id_usuario'));





            const resposta = window.confirm("Suas informações estão corretas? Uma vez salvo, o procedimento será finalizado e não pode ser mais atualizado, em caso de duvidas, revise suas informações!");
            if (resposta) {

            } else {
                setBotaoClicado(false);
                return;
            }



            // Verifica se a tabela existe e não está vazia
            if (!tabela || tabela.length === 0) {
                alert("A tabela não pode estar vazia. Adicione ao menos um item.");
                setBotaoClicado(false);
                return;
            }

            // Cria uma nova tabela apenas com itens cujo id seja menor que 100
            const novaTabela = tabela.filter(item => item.id < 100);

            // Imprime a nova tabela no console
            console.log("Nova Tabela (id < 100):", novaTabela);

            // Imprime a nova tabela em formato JSON
            console.log("JSON.stringify(novaTabela):", JSON.stringify(novaTabela));


            // Adiciona a tabela serializada
            formData.append("tabela", JSON.stringify(tabela));


            //formData.append('id_armazenamento', armazenamentoSelecionado.id_armazenamento);

            // Confirmação para adicionar ao estoque
            const shouldProceed = window.confirm(
                "Deseja prosseguir com a adição de " + tabela.length + " " + itemOrdemCompra.insumo.descricao + " ao estoque ?"
            );

            if (!shouldProceed) {
                setBotaoClicado(false);
                return;
            }




            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.put('/v1/protected/ordemservico/atualizarprocedimentoexecucao/' + idOrdemServico, formData,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {


                alert("Os novos itens foram adicionados ao Estoque, não esqueça de gerenciar cada um atualizado local do armazenamento, indetificadores, como número de série, sku, entre outros, e o teste de funcionamento!");


                listarInformacoes();





            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            setBotaoClicado(false);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }


    const [loading, setLoading] = useState(true);



    const [caixa, setCaixa] = useState([]);


    const [itensEstoque, setItensEstoque] = useState([]);




    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            //listar item ordem compra
            await api.get("/v1/protected/ordensdecompras/ordemdecompra/buscaritem/" + procedimentoExecucao.id_item_ordem_compra, {
                headers: headers
            }).then(function (response) {
                setItemOrdemCompra(response.data)

                //listar se tem itens_estoque ja cadastrado
                //listar armazenamentos
                api.get("v1/protected/almoxarifado/estoque/listarporitemordemcompra/" + procedimentoExecucao.id_item_ordem_compra, {
                    headers: headers
                }).then(function (responseItem) {


                    // 3️⃣ Processar itens já cadastrados no estoque
                    const itensEstoque = responseItem.data;
                    setItensEstoque(responseItem.data);

                    // 4️⃣ Montar tabela inicial com os itens do estoque
                    const tabelaInicial = itensEstoque.map((item, i) => ({
                        id: item.id_item_estoque || `estoque-${i + 1}`,
                        codigo_barras: item.codigo_barras || "",
                        numero_serie: item.numero_serie || "",
                        extras: item.extras || "",
                        id_armazenamento: item.armazenamento ? item.armazenamento.id_armazenamento : 0,
                        armazenamento: item.armazenamento,
                    }));

                    setTabela(tabelaInicial);

                    // 5️⃣ Calcular quantos itens restam para cadastrar
                    const totalRestantes = Math.max(
                        0,
                        procedimentoExecucao.quantidades_averiguar - tabelaInicial.length
                    );

                    // 6️⃣ Criar "caixa" com os itens restantes (não cadastrados)
                    const novosItens = Array.from({ length: totalRestantes }, (_, i) => ({
                        id: `${i + 1}`,
                        codigo_barras: "",
                        numero_serie: "",
                        extras: "",
                        id_armazenamento: 0,
                    }));

                    setCaixa(novosItens);


                    //listar armazenamentos
                    api.get("v1/protected/almoxarifado/armazenamento/listar", {
                        headers: headers
                    }).then(function (response) {
                        setArmazenamentos(response.data)
                        setLoading(false);
                    });


                });



            });

        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }


    function resumoArmazenamento(armazenamento) {
        const textoCompleto = returnDescricaoArmazenamento(armazenamento);
        // Retorna até 30 caracteres + "..." se necessário
        return textoCompleto;
        //return textoCompleto.length > 30 ? textoCompleto.substring(0, 30) + "..." : textoCompleto;
    }


    useEffect(() => {
        listarInformacoes();



    }, []);




    function handleSetArmazenamento(armazenamento) {
        setArmazenamentoSelecionado(armazenamento);
    }



    function returnDescricaoUnidade(unidade) {

        console.log("unidade: " + unidade);

        var nome = unidade.nome_fantasia;

        var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;


        var texto = nome + " | " + unidade.cnpj;
        return texto;
    }


    function returnDescricaoArmazenamento(armazenamento) {
        try {
            if (!armazenamento || typeof armazenamento !== "object") {
                return "Armazenamento não disponível";
            }



            const {
                descricao = "—",
                sala = "—",
                corredor = "—",
                bloco = "—",
                gondola = "—",
                prateleira = "—",
            } = armazenamento;

            return (
                returnDescricaoUnidade(armazenamento.unidade) + "\n" +
                "Descrição: " + descricao 
            );
        } catch (err) {
            console.error("Erro ao gerar descrição do armazenamento:", err);
            return "Erro ao processar dados de armazenamento";
        }
    }




    const handleDelete = (id) => {
        const item = tabela.find((it) => it.id === id);
        if (item) {
            setTabela((prev) => prev.filter((it) => it.id !== id));
            setCaixa((prev) => [...prev, item]); // devolve para caixa
        }
    };
    const onDragEnd = (result) => {
        if (!result.destination) return;

        // Drag da caixa para a tabela
        if (result.destination.droppableId === "tabela") {
            if (result.draggableId === "mover-todos") {
                // Mover todos os itens restantes
                setTabela((prev) => [...prev, ...caixa]);
                setCaixa([]); // esvazia a caixa
            } else {
                // mover item individual
                const item = caixa[result.source.index];
                setCaixa((prev) => prev.filter((_, idx) => idx !== result.source.index));
                setTabela((prev) => [...prev, item]);
            }
        }
    };

    const [selectedColumn, setSelectedColumn] = useState(null);


    const [menuAnchor, setMenuAnchor] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleRightClick = (event, row) => {
        event.preventDefault(); // evita o menu nativo do browser
        setSelectedRow(row);
        setMenuAnchor(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setMenuAnchor(null);
        setSelectedRow(null);
    };


    const handleCellEditCommit = (params) => {
        setTabela(prev =>
            prev.map(row =>
                row.id === params.id
                    ? { ...row, [params.field]: params.value }
                    : row
            )
        );
    };
    const handleReplicar = () => {
        if (!selectedRow || !selectedColumn) return;

        const startIndex = tabela.findIndex(row => row.id === selectedRow.id);
        if (startIndex === -1) return;

        const valor = selectedRow[selectedColumn]; // pega o valor da coluna correta

        setTabela(prev =>
            prev.map((row, idx) =>
                idx <= startIndex ? row : { ...row, [selectedColumn]: valor }
            )
        );

        handleCloseMenu();
    };


    const columns = [
        {
            field: "actions",
            headerName: "Ações",
            width: 100,
            renderCell: (params) =>
                parseInt(params.row.id, 10) < 100 ? (
                    <IconButton color="error" onClick={() => handleDelete(params.row.id)}>
                        <DeleteIcon />
                    </IconButton>
                ) : <span>No Estoque</span>
        },
        { field: "id", headerName: "ID", width: 50, editable: false },
        {
            field: "codigo_barras",
            headerName: "Código de Barras",
            width: 150,
            editable: true,
            renderCell: (params) => {
                const handleContext = (e) => {
                    e.preventDefault();
                    setSelectedRow(params.row);
                    setSelectedColumn("codigo_barras"); // coluna selecionada
                    setMenuAnchor(e.currentTarget);
                };

                return (
                    <div
                        style={{ width: "100%", height: "100%", padding: "0 4px" }}
                        onContextMenu={handleContext}
                    >
                        {params.value} {/* sempre mostra o valor atual */}
                    </div>
                );
            },
        },
        { field: "numero_serie", headerName: "Número de Série", width: 150, editable: true },
        { field: "extras", headerName: "Extras", width: 150, editable: true },
       {
    field: "armazenamento",
    headerName: "Armazenamento",
    width: 400,
    editable: true,
    renderCell: (params) => {

        const handleChange = (event) => {
            const idSelecionado = parseInt(event.target.value);
            setTabela(prev =>
                prev.map(row =>
                    row.id === params.row.id
                        ? { ...row, id_armazenamento: idSelecionado }
                        : row
                )
            );
        };

        const handleContext = (e) => {
            e.preventDefault();
            setSelectedRow(params.row);
            setSelectedColumn("id_armazenamento");
            setMenuAnchor(e.currentTarget);
        };

        const selectedValue = params.row.id_armazenamento || "";

        return (
            <div style={{ width: "100%" }} onContextMenu={handleContext}>
                <Select
                    value={selectedValue}
                    onChange={handleChange}
                    displayEmpty
                    fullWidth
                    // Aqui definimos como o valor selecionado será mostrado
                    renderValue={(selected) => {
                        if (!selected) return <em>Selecione</em>;

                        // Procuramos o item selecionado
                        const item = armazenamentos.find(a => a.id_armazenamento === selected);
                        if (!item) return "";

                        // Retorna em uma linha só, removendo \n
                        return resumoArmazenamento(item).replace(/\n/g, " ");
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 200,
                                width: '100%',
                            },
                        },
                    }}
                >
                    <MenuItem value="">
                        <em>Selecione</em>
                    </MenuItem>
                    {armazenamentos.map((armazenamento) => (
                        <MenuItem
                            key={armazenamento.id_armazenamento}
                            value={armazenamento.id_armazenamento}
                            style={{ whiteSpace: 'pre-line', paddingTop: 4, paddingBottom: 4 }}
                        >
                            <Typography component="span" style={{ whiteSpace: "pre-line" }}>
                                {resumoArmazenamento(armazenamento)}
                            </Typography>
                        </MenuItem>
                    ))}
                </Select>
            </div>
        );
    }
}


    ];






    return (
        <div>
            {
                !loading &&
                (
                    <Grid
                        style={{ paddingTop: 5 }}
                        container
                        direction="row"
                        item xs={12}
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                    >

                        <Grid item xs={8}
                            style={{ paddingLeft: 5 }}
                        >

                            <Typography
                                align="center"
                                style={{ fontSize: 18, fontWeight: 'bold' }}
                                sx={{ fontWeight: "bold", mb: 2 }}
                            >
                                {procedimentoExecucao.quantidades_averiguar} unidades de {procedimentoExecucao.procedimento?.nome.replace(
                                    "Verificar Recebimento de Mercadoria - ",
                                    ""
                                )}
                            </Typography>

                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            item xs={3}
                        >
                            {itensEstoque.length < procedimentoExecucao.quantidades_averiguar ?
                                (
                                    <Button style={{ marginTop: 5 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={salvar}
                                        disabled={botaoClicado}
                                    > Salvar  </Button>
                                ) : (<Button style={{ marginTop: 5 }}
                                    variant="contained"
                                    color="secondary"
                                > Todos os Itens em Estoque  </Button>)
                            }
                        </Grid>
                        <Grid item xs={8} style={{ padding: 5 }}>
                            <TextField
                                variant="standard"
                                name="observacoes"
                                label="Observações"
                                required
                                id="observacoes"
                                value={observacoes}
                                onChange={(e) => setObservacoes(e.target.value)}
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </Grid>



                        <DragDropContext onDragEnd={onDragEnd}>
                            <Grid container spacing={1}>
                                {/* Caixa de Encomenda (lado esquerdo) */}

                                <Grid item xs={4}
                                    style={{ paddingLeft: 5 }}
                                >
                                    <Typography
                                        align="center"
                                        variant="h6"
                                        sx={{ fontWeight: "bold", mb: 2 }}
                                    >
                                        Caixa de Encomenda ({caixa.length} itens restantes)
                                    </Typography>

                                    <Droppable droppableId="caixa" direction="horizontal">
                                        {(provided) => (
                                            <Box
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                sx={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 2,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    p: 2,
                                                    minHeight: 250,
                                                    border: "4px solid #5D4037",
                                                    borderRadius: 0,
                                                    bgcolor: "#D7CCC8",

                                                }}
                                            >
                                                {/* Draggable "Mover Todos" */}
                                                {caixa.length > 1 && (
                                                    <Draggable draggableId="mover-todos" index={-1}>
                                                        {(prov) => (
                                                            <Box
                                                                ref={prov.innerRef}
                                                                {...prov.draggableProps}
                                                                {...prov.dragHandleProps}
                                                                sx={{
                                                                    width: 90,
                                                                    height: 90,
                                                                    border: "2px dashed #3E2723",
                                                                    borderRadius: 1,
                                                                    bgcolor: "#BCAAA4",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    textAlign: "center",
                                                                    fontWeight: "bold",
                                                                    fontSize: "0.7rem",
                                                                    px: 1,
                                                                    cursor: "grab",
                                                                }}
                                                            >
                                                                📦 Todos
                                                            </Box>
                                                        )}
                                                    </Draggable>
                                                )}

                                                {/* Itens individuais */}
                                                {caixa.map((item, index) => (
                                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                                        {(prov) => (
                                                            <Box
                                                                ref={prov.innerRef}
                                                                {...prov.draggableProps}
                                                                {...prov.dragHandleProps}
                                                                sx={{
                                                                    width: 90,
                                                                    height: 90,
                                                                    border: "1px solid #3E2723",
                                                                    borderRadius: 1,
                                                                    bgcolor: "#EFEBE9",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    textAlign: "center",
                                                                    fontWeight: "bold",
                                                                    fontSize: "0.7rem",
                                                                    px: 1,
                                                                    cursor: "grab",
                                                                    overflow: "hidden",
                                                                    whiteSpace: "nowrap",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {(() => {
                                                                    try {
                                                                        const descricao =
                                                                            itemOrdemCompra?.insumo?.descricao?.trim() || "Item sem descrição";
                                                                        return `📦 ${descricao}`;
                                                                    } catch (err) {
                                                                        console.error("Erro ao exibir descrição do item:", err);
                                                                        return "📦 Erro ao carregar item";
                                                                    }
                                                                })()}
                                                            </Box>
                                                        )}
                                                    </Draggable>
                                                ))}

                                                {provided.placeholder}
                                            </Box>
                                        )}
                                    </Droppable>
                                </Grid>

                                {/* Tabela (lado direito) */}
                                <Grid item xs={7}>

                                    <Droppable droppableId="tabela">
                                        {(provided) => (
                                            <Box ref={provided.innerRef} {...provided.droppableProps}>
                                                <div style={{ height: 500, width: "100%" }}>
                                                    <DataGrid
                                                        rows={tabela}
                                                        columns={columns}
                                                        pageSize={9999}
                                                        rowsPerPageOptions={[9999]}
                                                        disableSelectionOnClick
                                                        processRowUpdate={(newRow, oldRow) => {
                                                            // Atualiza o estado com o novo valor da linha
                                                            setTabela((prev) =>
                                                                prev.map((row) => (row.id === newRow.id ? newRow : row))
                                                            );
                                                            return newRow;
                                                        }}
                                                        experimentalFeatures={{ newEditingApi: true }} // necessário em algumas versões
                                                    />
                                                </div>
                                                {provided.placeholder}
                                            </Box>
                                        )}
                                    </Droppable>
                                </Grid>
                            </Grid>
                        </DragDropContext>
                    </Grid>

                )
            }

            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleCloseMenu}
            >
                <MenuItem onClick={handleReplicar}>Replicar para baixo</MenuItem>
            </Menu>


        </div >
    );
}


